// test1427
(1427 && 0);
